export function parseURI(uriKey: string, uri: string, encode = true): string {
    return `${uriKey}=${encode ? encodeURIComponent(uri) : uri}`;
}
